<span class="snack-bar-wrapper">
  <span>{{ title }}</span>
  @if (icon) {
    <svg>
      <use [attr.xlink:href]="'#' + icon"></use>
    </svg>
  }
</span>
